import script from "./DeliveryPrint.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeliveryPrint.vue?vue&type=script&setup=true&lang=ts"

import "./DeliveryPrint.vue?vue&type=style&index=0&id=6c52fcfd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c52fcfd"]])

export default __exports__